import { auth } from '../cn/auth/index';
import { administration } from '../cn/administration/index';
import { tests } from '../cn/tests/index';
import { homes } from '../cn/homes/index';
import { users } from '../cn/users/index';
import { dashboard } from '../cn/dashboard';
import { training } from '../cn/training/index';
import { reports } from '../cn/reports/index';

// Messages for EN language
const strings = {
    appName: '负荷识别和能耗监控系统',
    loading: '加载中...',
    language: {
        sk: '斯洛伐克语',
        en: '英语',
        de: '德语',
        zh: '中文'
    },
    ok: '确定',
    add: '添加',
    permissionsIsAdminTag: '管理员',
    permissionsIsNotAdminTag: '用户',
    permissionsIsTesterTag: '测试人员',
    permissionsIsInstallerTag: '安装人员',
    select: '选择',
    save: '保存',
    download: '下载',
    close: '关闭',
    cancel: '取消',
    version: '版本',
    reload: '重载',
    edit: '编辑',
    invite: '邀请',
    adminAddUser: '添加一个新所有者',
    delete: '删除',
    undelete: '取消删除',
    sureToUndeleteTitle: '确定取消删除该记录?',
    sureToDeleteTitle: '确定删除该记录?',
    maxLengthReached: '达到的最大长度',
    actionsLabel: '行为',
    logoutLink: '退出',
    dashboardRoute: '可视化看板',
    noDataAvailable: '无数据',
    requiredField: '需要填写',
    emailFormatField: '邮件地址格式不正确.',
    msgErrorApi: '从API获取数据错误',
    perMinute: '每分钟.',
    id: '序号',
    auth,
    administration,
    tests,
    homes,
    users,
    dashboard,
    training,
    reports
};

export default strings;
